<ng-container>
  <app-toast-message></app-toast-message>
  <app-front-facing-nav-bar></app-front-facing-nav-bar>

  <div class="container-fluid" [ngClass]="taxonomyDetail?'pt-0':''">
    <router-outlet></router-outlet>
  </div>

</ng-container>
